<template>
  <Dialog
    :title="type === 'add' ? '新增字典数据' : '修改字典数据'"
    :visible.sync="dialogVisible"
    width="520px"
    :close-on-click-modal="false"
    :before-close="cancel"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="字典类型">
        <el-input v-model.trim="form.dictType" disabled></el-input>
      </el-form-item>
      <el-form-item label="数据标签" prop="dictLabel">
        <el-input
          v-model.trim="form.dictLabel"
          placeholder="请输入数据标签"
        ></el-input>
      </el-form-item>
      <el-form-item label="数据键值" prop="dictValue">
        <el-input
          v-model.trim="form.dictValue"
          placeholder="请输入数据键值"
        ></el-input>
      </el-form-item>
      <el-form-item label="显示排序" prop="dictSort">
        <el-input-number
          v-model="form.dictSort"
          :min="0"
          controls-position="right"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio label="0">正常</el-radio>
          <el-radio label="1">停用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否默认" prop="isDefault">
        <el-radio-group v-model="form.isDefault">
          <el-radio label="Y">是</el-radio>
          <el-radio label="N">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="样式类名" prop="cssClass">
        <el-select
          v-model="form.cssClass"
          placeholder="请选择样式类名"
          clearable
          style="width: 100%;"
        >
          <el-option
            v-for="item in cssClassOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          v-model.trim="form.remark"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button plain round size="small" @click="cancel">取 消</el-button>
      <el-button plain round size="small"
        type="primary"
        :loading="submitLoading"
        @click="submitForm"
        >确 定</el-button
      >
    </div>
  </Dialog>
</template>

<script>
import { getDictData, addDictData, updateDictData } from "@/api/system";

const CSS_CLASS_OPTIONS = [
  { label: "默认(default)", value: "default" },
  { label: "主要(primary)", value: "primary" },
  { label: "成功(success)", value: "success" },
  { label: "信息(info)", value: "info" },
  { label: "警告(warning)", value: "warning" },
  { label: "危险(danger)", value: "danger" }
];

const defaultForm = dictType => ({
  dictCode: undefined,
  dictType: dictType || "",
  dictLabel: "",
  dictValue: "",
  dictSort: 0,
  status: "0",
  isDefault: "N",
  cssClass: "default",
  remark: ""
});

export default {
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      type: "add",
      cssClassOptions: CSS_CLASS_OPTIONS,
      form: defaultForm()
    };
  },
  computed: {
    rules() {
      return {
        dictLabel: [
          { required: true, message: "请输入数据标签", trigger: "blur" }
        ],
        dictValue: [
          { required: true, message: "请输入数据键值", trigger: "blur" }
        ],
        dictSort: [
          { required: true, message: "请输入显示排序", trigger: "blur" }
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }]
      };
    }
  },
  methods: {
    async open(type, row = {}, dictType) {
      this.type = type;
      this.dialogVisible = true;
      if (type === "edit" && row.dictCode) {
        try {
          const result = await getDictData(row.dictCode);
          const data = result.data || {};
          this.form = {
            dictCode: data.dictCode,
            dictType: data.dictType || dictType,
            dictLabel: data.dictLabel || "",
            dictValue: data.dictValue || "",
            dictSort: data.dictSort != null ? data.dictSort : 0,
            status: data.status || "0",
            isDefault: data.isDefault || "N",
            cssClass: data.cssClass || "default",
            remark: data.remark || ""
          };
          this.$nextTick(() => {
            this.$refs.formRef && this.$refs.formRef.clearValidate();
          });
        } catch (e) {
          this.cancel();
        }
      } else {
        this.form = defaultForm(dictType);
        this.$nextTick(() => {
          this.$refs.formRef && this.$refs.formRef.clearValidate();
        });
      }
    },
    async submitForm() {
      if (this.submitLoading) return;
      try {
        await this.$refs.formRef.validate();
      } catch (e) {
        return false;
      }
      this.submitLoading = true;
      const request = this.form.dictCode ? updateDictData : addDictData;
      try {
        await request(this.form);
        this.$message.success(this.form.dictCode ? "编辑成功" : "保存成功");
        this.cancel();
        this.$emit("success");
      } catch (e) {
      } finally {
        this.submitLoading = false;
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.form = defaultForm();
      this.$refs.formRef && this.$refs.formRef.resetFields();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/system/Dict/data/DictDataForm.vue